// extracted by mini-css-extract-plugin
module.exports = {"icon":"kebabMenu_icon__Ht707","menuItem":"kebabMenu_menuItem__28M7W"};